// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"5b9ca896","718":"cfba5850","838":"5b9ca896"}[chunkId] + ".chunk.css";
};